<div class="search-box">
    <input
        type="search"
        name="searchAttributeFilter"
        autocomplete="off"
        [(ngModel)]="searchAttributeFilter"/>

    <span class="icon-search1"></span>
</div>

<ul class="dataset-list">
    @for (attribute of metadataList | textValueFilter: searchAttributeFilter; track $index) {
        <li
            (click)="onSelectAttribute(attribute)"
            [ngClass]="{'selected': (selectedDashboardFilter.name === attribute.value)}"
            innerHTML="{{ attribute.text | highlight : searchAttributeFilter }}"
        >
        </li>
    }
</ul>
